import { render, staticRenderFns } from "./DealsSectionWithFilters.vue?vue&type=template&id=77a0e3ee&scoped=true&"
import script from "./DealsSectionWithFilters.vue?vue&type=script&lang=js&"
export * from "./DealsSectionWithFilters.vue?vue&type=script&lang=js&"
import style0 from "./DealsSectionWithFilters.vue?vue&type=style&index=0&id=77a0e3ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a0e3ee",
  null
  
)

export default component.exports